import { render, staticRenderFns } from "./ColumnTaxonomiesExpand.vue?vue&type=template&id=420cfdbb"
import script from "./ColumnTaxonomiesExpand.vue?vue&type=script&lang=js"
export * from "./ColumnTaxonomiesExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports